import React from 'react';
import { Box, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { API_URL } from '../constants';

const HASH_RE = /^[A-Za-z0-9_-]{8,64}$/;

export default function SwedenSnusReportPublicView() {
  const { hash, productId } = useParams();
  if (!hash || !HASH_RE.test(hash)) {
    return (
      <Box sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom>
          Report not found
        </Typography>
        <Typography color="text.secondary">This report link is not valid.</Typography>
      </Box>
    );
  }

  const product = productId ? `/p/${encodeURIComponent(productId)}` : '';
  const src = `${API_URL}/sweden-snus-admin/r/${encodeURIComponent(hash)}${product}`;
  return (
    <iframe
      title="Shelf report"
      src={src}
      style={{
        position: 'fixed',
        inset: 0,
        width: '100%',
        height: '100%',
        border: 'none',
        display: 'block',
        background: '#f4f7f6',
      }}
    />
  );
}
